module.exports = __webpack_public_path__ + "img/1 (89).e0806dd6.png";